import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import Table from "./table";
import Toolbar from "./toolbar";
import { JobBoardContext } from "./context";

const JobBoard = ({
  recycledInquiries,
  artistLoggedIn,
  artistServices,
  ...props
}) => {
  const countries = useMemo(() => {
    return [
      ...new Set(
        recycledInquiries.map((inquiry) => {
          if (inquiry.country_code) {
            return inquiry.country_code.toLowerCase();
          }
          return null;
        }),
      ),
    ];
  }, [recycledInquiries]);
  const creativeFields = useMemo(() => {
    return [
      ...new Set(
        recycledInquiries.map((inquiry) => {
          if (inquiry.kind_of_art) {
            return inquiry.kind_of_art;
          }
          return null;
        }),
      ),
    ];
  }, [recycledInquiries]);
  const occasions = useMemo(() => {
    return [
      ...new Set(
        recycledInquiries.map((inquiry) => {
          if (inquiry.kind_of_moment) {
            return inquiry.kind_of_moment;
          }
          return null;
        }),
      ),
    ];
  }, [recycledInquiries]);
  const [selectedCountries, setSelectedCountries] = useState([...countries]);
  const [selectedCreativeFields, setSelectedCreativeFields] = useState([
    ...creativeFields,
  ]);
  const [selectedOccasions, setSelectedOccasions] = useState([...occasions]);

  const getContextValue = () => {
    return {
      selectedCountries,
      setSelectedCountries,
      countries,
      selectedCreativeFields,
      setSelectedCreativeFields,
      creativeFields,
      selectedOccasions,
      setSelectedOccasions,
      occasions,
    };
  };
  return (
    <JobBoardContext.Provider value={getContextValue()}>
      <div>
        <Toolbar artistLoggedIn={artistLoggedIn} {...props} />
        <Table
          recycledInquiries={recycledInquiries}
          artistLoggedIn={artistLoggedIn}
          artistServices={artistServices}
        />
      </div>
    </JobBoardContext.Provider>
  );
};

JobBoard.propTypes = {
  recycledInquiries: PropTypes.array.isRequired,
  artistLoggedIn: PropTypes.bool,
  artistServices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      profileId: PropTypes.number,
      profileName: PropTypes.string,
    }),
  ).isRequired,
  serviceTypes: PropTypes.object.isRequired,
};

JobBoard.defaultProps = {
  artistLoggedIn: false,
};

export default JobBoard;
